import React from "react";
import "./AboutTrust.css";
import Banner2 from "../Images/GarudasenaBanners.JPG";

const AboutTrust = () => {
  return (
    <section id="about-trust">
      <div className="about-container">
        <div className="about-image">
          <img src={Banner2} alt="SASCCT Trust" />
        </div>
        <div className="about-text">
          <h2>About the Trust</h2>
          <p>
            <strong>Sri Ashtothara Shatha (108) Chukkala’s Charitable Trust</strong> (SASCCT)
            is a spiritual and service-oriented organization devoted to serving
            devotees and humanity through charitable and devotional activities.
            The Trust upholds the divine principle of{" "}
            <em>“Service to Devotees is Service to Lord Sri Venkateshwara Swamy.”</em>
          </p>
          <a href="/about-us">Read More →</a>
        </div>
      </div>
    </section>
  );
};

export default AboutTrust;
